module.exports = __webpack_public_path__ + "img/item_link_engraving@2x.586b836.webp";